<template>
  <div id="app">
    <Hello/>
  </div>
</template>

<script>
import Hello from './components/Hello.vue'

export default {
  name: 'App',
  components: {
    Hello
  }
}
</script>

<style>
@font-face {
  font-family: 'Manrope';
  src:
    url('/fonts/Manrope[wght].ttf');
  font-weight: normal;
  font-style: normal;
  font-display: block;
}
body {
  margin: 0;
  font-size: 14px !important;
}
#app {
  font-family: Manrope, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  font-weight: 400;
}
small {
  font-size: .6em;
  vertical-align: text-top;
}
</style>
